<template>
  <div>
    <v-btn :to="{name: 'tasks'}"
           block>
      {{ $t('tasks') }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'Home',
}
</script>